import React from 'react';
import useFetch from 'components/shared/hooks/useFetch';
import { routes } from 'constants/config';
import { Card } from 'ui';

const ScenarioEngagementContainer = ({ scenarioId, groupId }) => {
  const { data: completionStatistic, loading: completionsLoading } = useFetch(
    routes.ON_DEMAND_PRACTICE.CREATOR.ENGAGEMENTS.COMPLETIONS(
      scenarioId,
      groupId,
    ),
  );
  const { data: viewStatistic, loading: viewsLoading } = useFetch(
    routes.ON_DEMAND_PRACTICE.CREATOR.ENGAGEMENTS.VIEWS(scenarioId, groupId),
  );
  const { data: uniqueViewStatistic, loading: uniqueViewsLoading } = useFetch(
    routes.ON_DEMAND_PRACTICE.CREATOR.ENGAGEMENTS.UNIQUE_VIEWS(
      scenarioId,
      groupId,
    ),
  );

  return (
    <div className="ScenarioEngagementContainer">
      <h3 className="ff-ss fw-b ws-pr mb-32 mt-32">
        {t('practice.on_demand_practice.overview.scenario_engagement.heading')}
      </h3>
      <Card className="mt-30">
        <Card.Content padding="large" className="d-f ai-c jc-c">
          <div className="ScenarioEngagementContainer-completions d-f ai-c jc-c fg-1 fd-c">
            <h1 className="ff-ss fw-b">
              {!completionsLoading && completionStatistic.completions}
            </h1>
            <span className="fz-18">
              {completionsLoading &&
                t(
                  'practice.on_demand_practice.overview.scenario_engagement.loading',
                )}
              {!completionsLoading && (
                <a
                  className="u-linkBtn"
                  href={routes.ON_DEMAND_PRACTICE.CREATOR.ATTEMPTS.INDEX(
                    scenarioId,
                    groupId,
                  )}
                >
                  {t(
                    'practice.on_demand_practice.overview.scenario_engagement.completions',
                  )}
                </a>
              )}
            </span>
          </div>
          <div className="ScenarioEngagementContainer-views d-f ai-c jc-c fg-1 fd-c">
            <h1 className="ff-ss fw-b">
              {!viewsLoading && viewStatistic.views}
            </h1>
            <span className="fz-18">
              {completionsLoading &&
                t(
                  'practice.on_demand_practice.overview.scenario_engagement.loading',
                )}
              {!completionsLoading &&
                t(
                  'practice.on_demand_practice.overview.scenario_engagement.views',
                )}
            </span>
          </div>
          <div className="ScenarioEngagementContainer-uniqueViews d-f ai-c jc-c fg-1 fd-c">
            <h1 className="ff-ss fw-b">
              {!uniqueViewsLoading && uniqueViewStatistic.uniqueViews}
            </h1>
            <span className="fz-18">
              {completionsLoading &&
                t(
                  'practice.on_demand_practice.overview.scenario_engagement.loading',
                )}
              {!completionsLoading &&
                t(
                  'practice.on_demand_practice.overview.scenario_engagement.unique_views',
                )}
            </span>
          </div>
        </Card.Content>
      </Card>
    </div>
  );
};

export default ScenarioEngagementContainer;
